import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'
import { Loader } from '.'

export class SectionLoader extends Component {

  static propTypes = {
    size: PropTypes.number,
    color: PropTypes.string
  }

  static defaultProps = {
    size: 100,
    color: '#FF4A00'
  }

  render = () =>
    <div className={styles.loaderWrapper}>
      <div className={styles.loaderInner}>
        <Loader size={this.props.size} color={this.props.color}/>
      </div>
    </div>
}


const styles = StyleSheet({
  loaderWrapper: {
    overflow: 'hidden',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255, 255, 255, 0.1)',
    zIndex: 1000
  },
  loaderInner: {
    zIndex: 100,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '-61px',
    marginTop: '-81px'
  }
})

export default SectionLoader
